import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { Route, Switch, withRouter } from 'react-router-dom';
import NotFound from '../NotFound';
import Orders from '../orders';
import OrdersPipeline from './pipeline';

export const subServicesRoutes = [
  {
    type: 'lienSearch',
    name: 'Lien Searches'
  },
  {
    type: 'estoppel',
    name: 'Estoppels'
  },
  {
    type: 'survey',
    name: 'Surveys'
  }
];

export const allSubRoute = {
  type: 'all',
  name: 'All'
};

const Services = ({ createdService, onServiceHandled }) => {
  return (
    <Container fluid>
      <Switch>
        <Route exact path="/services/pipeline">
          <Orders createdService={createdService} onServiceHandled={onServiceHandled} />
        </Route>
        <Route exact path="/services/:id" render={props => <OrdersPipeline serviceDetails={true} {...props} />} />

        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </Container>
  );
};

export default withRouter(Services);
